import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { DatePicker, Descriptions, Form, Input, Modal, Switch, notification, Spin } from 'antd'
import dayjs from '@plugins/local-dayjs'

import { updatePositionApplyControlBatch } from '../../../../common/request'
import ResponseCode from '../../../../common/response-code'

const ConfigPositionApplyControlModal = forwardRef((props, ref) => {
  const [form] = Form.useForm()
  const [notifyApi, contextHolder] = notification.useNotification()
  const [modalVisible, setModalVisible] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [modalTitle, setModalTitle] = useState('配置报名控制')
  const [isBatchSetting, setIsBatchSetting] = useState(false)

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  useEffect(() => {
    if (!modalVisible) {
      return
    }

    const batch = props.positionItemList.length > 1
    setIsBatchSetting(batch)
    setModalTitle(batch ? '批量配置报名控制' : '配置报名控制')

    if (batch) {
      form.setFieldsValue({
        active: true,
        hide: false,
        message: '',
        deadline: undefined
      })
      return
    }

    const position = props.positionItemList[0] || {}
    form.setFieldsValue({
      active: position.active ?? true,
      hide: position.hide ?? false,
      message: position.message || '',
      deadline: position.deadline ? dayjs(position.deadline) : undefined
    })
  }, [modalVisible, props.positionItemList, form])

  const showModal = () => {
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
    form.resetFields()
  }

  const onOk = () => {
    form.validateFields().then(fields => {
      setModalLoading(true)
      const params = {
        ids: props.positionItemList.map(item => item._id),
        active: fields.active,
        hide: fields.hide,
        message: fields.message || '',
        deadline: fields.deadline ? fields.deadline.format('YYYY-MM-DD HH:mm:ss') : undefined
      }

      updatePositionApplyControlBatch(params).then(res => {
        setModalLoading(false)
        if (res.code === ResponseCode.success) {
          notifyApi.success({
            message: '操作成功'
          })
          hideModal()
          props.insertSuccess?.()
        } else {
          Modal.error({
            title: '错误',
            content: res.msg,
            centered: true
          })
        }
      }).catch(() => {
        setModalLoading(false)
        Modal.error({
          title: '网络错误',
          content: '保存报名控制配置失败',
          centered: true
        })
      })
    }).catch(() => {})
  }

  const getDescriptions = () => {
    if (isBatchSetting) {
      return null
    }

    const position = props.positionItemList[0] || {}
    return (
      <Descriptions className="mb-3" column={ 2 } size="small">
        <Descriptions.Item label="单位名称">{ position.unitName }</Descriptions.Item>
        <Descriptions.Item label="单位代码">{ position.unitCode }</Descriptions.Item>
        <Descriptions.Item label="职位名称">{ position.positionName }</Descriptions.Item>
        <Descriptions.Item label="职位代码">{ position.positionCode }</Descriptions.Item>
      </Descriptions>
    )
  }

  return (
    <div ref={ ref }>
      { contextHolder }
      <Modal
        title={ modalTitle }
        width={ 720 }
        open={ modalVisible }
        onCancel={ hideModal }
        onOk={ onOk }
        okText="保存"
        confirmLoading={ modalLoading }
        destroyOnClose
      >
        <Spin spinning={ modalLoading }>
          { getDescriptions() }
          <Form
            form={ form }
            layout="vertical"
            initialValues={ {
              active: true,
              hide: false,
              message: ''
            } }
          >
            <Form.Item
              label="是否开启职位报名"
              name="active"
              valuePropName="checked"
              rules={ [{ required: true, message: '请选择是否开启职位报名' }] }
            >
              <Switch checkedChildren="开启" unCheckedChildren="关闭"></Switch>
            </Form.Item>
            <Form.Item
              label="职位报名截止时间"
              name="deadline"
            >
              <DatePicker
                showTime
                style={ { width: '100%' } }
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择截止时间"
              ></DatePicker>
            </Form.Item>
            <Form.Item
              label="职位报名控制公告"
              name="message"
            >
              <Input.TextArea
                rows={ 4 }
                placeholder="请输入报名控制公告（选填）"
                maxLength={ 500 }
                showCount
              ></Input.TextArea>
            </Form.Item>
            <Form.Item
              label="是否隐藏职位（隐藏职位考生将无法查询到该职位）"
              name="hide"
              valuePropName="checked"
              rules={ [{ required: true, message: '请选择是否隐藏职位' }] }
            >
              <Switch checkedChildren="隐藏" unCheckedChildren="显示"></Switch>
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </div>
  )
})

export default ConfigPositionApplyControlModal
